import * as XLSX from 'xlsx';
import {AfterViewChecked, Component, ViewChild} from '@angular/core';
import {LoadingService} from '../../../services/loading.service';
import {MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/typings/stepper';
import {SecondStepComponent} from './second-step/second-step.component';
import {StepperService} from '../../../layout/services/stepper.service';

@Component({
  selector: 'app-upload-budget-dialog',
  templateUrl: './upload-budget-dialog.component.html'
})
export class UploadBudgetDialogComponent implements AfterViewChecked {
  @ViewChild('secondStep', {static: true}) secondStep: SecondStepComponent;
  @ViewChild('stepper', {static: true}) stepper: MatStepper;

  public addresses: any[];
  public disableButton: boolean;
  public file: any;

  constructor(private loadingService: LoadingService,
              private matDialogRef: MatDialogRef<UploadBudgetDialogComponent>,
              public stepperService: StepperService) {
    this.disableButton = true;
  }

  public ngAfterViewChecked() {
    if (this.stepper) {
      let status;
      switch (this.stepper.selectedIndex) {
        case 0:
          status = this.file === undefined;
          break;
        case 1:
          status = false;
          break;
      }
      if (status !== this.disableButton) {
        setTimeout(() => {
          this.disableButton = status;
        }, 0);
      }
    }
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public async goToNextStep(): Promise<any> {
    if (this.stepper.selectedIndex === 0) {
      this.loadingService.show();
      setTimeout(async () => {
        const promise = new Promise((resolve) => {
          const reader: FileReader = new FileReader();
          reader.onload = (file: any) => {
            const fileName: string = file.target.result;
            const workBook: XLSX.WorkBook = XLSX.read(fileName, {
              dateNF: 'YYYY-MM-DD',
              type: 'binary'
            });
            const workSheetName: string = workBook.SheetNames[0];
            const workSheet: XLSX.WorkSheet = workBook.Sheets[workSheetName];
            const importedAddresses: any[] = XLSX.utils.sheet_to_json(workSheet, {
              header: 1,
              raw: false
            });
            importedAddresses.shift();
            this.addresses = [];
            for (const address of importedAddresses) {
              let model;
              if (address[Object.keys(address)[5]] && address[Object.keys(address)[6]] && address[Object.keys(address)[7]]) {
                model = {
                  salesGroup: address[Object.keys(address)[0]],
                  materialId: address[Object.keys(address)[1]],
                  category: address[Object.keys(address)[2]],
                  led: address[Object.keys(address)[3]],
                  initialBudget: address[Object.keys(address)[4]],
                  destroys: address[Object.keys(address)[5]],
                  bound: address[Object.keys(address)[6]],
                  sent: address[Object.keys(address)[7]]
                };
              } else {
                model = {
                  salesGroup: address[Object.keys(address)[0]],
                  materialId: address[Object.keys(address)[1]],
                  category: address[Object.keys(address)[2]],
                  led: address[Object.keys(address)[3]],
                  initialBudget: address[Object.keys(address)[4]],
                  destroys: 0,
                  bound: 0,
                  sent: 0
                };
              }
              this.addresses.push(model);
            }
            resolve({});
          };
          reader.readAsBinaryString(this.file.file);
        });
        await promise;
        this.loadingService.hide();
        // @ts-ignore
        this.stepperService.goToNextStep(this.stepper);
      }, 500);
    } else {
      await this.secondStep.submitProcess();
      this.matDialogRef.close('success');
    }
  }
}
